import React, { useRef } from 'react';
import { ModalOverlay, ModalContent, ModalBody } from './modal.style';

const Modal = ({ isOpen, onClose, children }) => {
  const modalRef = useRef(null);

  const handleKeyDown = (event) => {
    if (event.key === 'Escape') {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <ModalOverlay
      onClick={onClose}
      onKeyDown={handleKeyDown}
      tabIndex={-1}
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-title"
      ref={modalRef}
    >
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <ModalBody>{children}</ModalBody>
      </ModalContent>
    </ModalOverlay>
  );
};

export default Modal;
